import { Box, Modal } from 'app/components/design-system-components'

interface RequireDetailsModalProps {
  toggleModal: () => void
  teamName?: string
  detailsModalContent: React.ReactNode
  primaryAction?: () => void
  primaryLabel?: string
}

function RequireDetailsModal({
  toggleModal,
  detailsModalContent,
  primaryAction,
  primaryLabel,
}: RequireDetailsModalProps) {
  return (
    <Modal
      modalHeading="Please add Details"
      modalBody={<Box lineHeight="1.2">{detailsModalContent}</Box>}
      modalFooter={null}
      primaryLabel={primaryLabel || null}
      primaryAction={primaryAction || null}
      toggleModal={toggleModal}
      showPrimaryButton={!!primaryAction}
      showSecondaryButton={!primaryAction || true}
      secondaryLabel={primaryAction ? 'Cancel' : 'Close'}
      secondaryAction={toggleModal}
    />
  )
}

export default RequireDetailsModal
